import React from 'react';
import { Typography } from '../../../../interfaces/typography';
import { SPEEDS } from './constants';
import { formatMsToTimeString } from './timeUtils';

interface ControlsProps {
  isPlaying: boolean;
  currentSpeed: number;
  currentTimeInMS: number;
  endTime?: number;
  onPlayPause: () => void;
  onSpeedChange: (speed: number) => void;
  disabled?: boolean;
}

const Button: React.FC<{ play: boolean; onPlayerClick: () => void }> = ({ play, onPlayerClick }) => {
  return (
    <div 
      onClick={onPlayerClick} 
      className="hover:bg-slate-300 cursor-pointer" 
      style={{
        width: '100%', 
        height: '100%', 
        padding: '8px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        border: "1px solid rgba(91, 101, 124, 0.25)", 
        borderRadius: '50%', 
        boxShadow: '0px 3px 3px rgb(0 0 0 / 10%)'
      }}
    >
      {play ? (
        <svg className="w-5/6 h-5/6" viewBox="0 0 40 60">
          <polygon points="0,0 15,0 15,60 0,60" />
          <polygon points="25,0 40,0 40,60 25,60" />
        </svg>
      ) : (
        <svg className="w-5/6 h-5/6" viewBox="0 0 50 60">
          <polygon points="0,0 50,30 0,60" />
        </svg>
      )}
    </div>
  );
};

export const Controls: React.FC<ControlsProps> = ({
  isPlaying,
  currentSpeed,
  currentTimeInMS,
  endTime = 0,
  onPlayPause,
  onSpeedChange,
}) => {
  const handleSpeedClick = () => {
    const nextIndex = SPEEDS.indexOf(currentSpeed) + 1;
    onSpeedChange(SPEEDS[nextIndex % SPEEDS.length])
  }

  return (
    <div className="w-fit flex flex-col gap-1 items-center p-1 justify-between h-full">
      <div className="flex flex-row gap-1">
      <div style={{ width: '30px', minWidth: '30px', height: '30px', minHeight: '30px' }}>
        <Button play={isPlaying} onPlayerClick={onPlayPause} />
      </div>

      <div 
        onClick={handleSpeedClick} 
        className="hover:bg-slate-300 cursor-pointer" 
        style={{
          width: '30px', 
          minWidth: '30px', 
          height: '30px', 
          minHeight: '30px', 
          padding: '6px', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          border: "1px solid rgba(91, 101, 124, 0.25)", 
          borderRadius: '50%', 
          boxShadow: '0px 3px 3px rgb(0 0 0 / 10%)'
        }}
      >
        <Typography variant="caption">
          {currentSpeed + "x"} 
        </Typography>
      </div>
      </div>
      <div className="flex flex-row gap-1">
        <Typography variant="caption">{formatMsToTimeString(currentTimeInMS)}</Typography>
        <Typography variant="caption">/</Typography>
        <Typography variant="caption">{formatMsToTimeString(endTime)}</Typography>
      </div>
    </div>
  );
}; 